import { ActionTypeEnum } from 'redux/ActionTypeEnum';

// home
const homeCategoryActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.home_categories_request,
	payload,
	meta,
});

const homeCategoryActionSuccess = (payload) => ({
	type: ActionTypeEnum.home_categories_success,
	payload,
});

// search
const searchCategoryActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.search_categories_request,
	payload,
	meta,
});
const searchCategoryActionSuccess = (payload) => ({
	type: ActionTypeEnum.search_categories_success,
	payload,
});

export {
	searchCategoryActionRequest,
	searchCategoryActionSuccess,
	homeCategoryActionRequest,
	homeCategoryActionSuccess,
};
